<template>
  <div class="userTemplate" v-cloak>
    <canvas id="cvs" :style="{height:'100%'}"></canvas>
    <el-row class="bigBox">
      <el-col :md={span:10,offset:7} class="logoPlatform">
        <img :src="logoUrl" fit="fill" />
      </el-col>
      <el-col :md={span:10,offset:7} class="box" style="display: flex;flex-direction: column">
        <el-row class="title">
          <slot name="title"></slot>
        </el-row>
        <el-row class="content">
          <slot name="content"></slot>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "UserTemplate",
  data() {
    return {
      logoUrl: require("@/assets/login/yunKongLogo.png"),
      logoItem: require("@/assets/login/yunKongLogo.png"),
    }
  },
  mounted() {
    this.logoUrl = this.logoItem
    require('@/assets/js/canvas/script.js')
  }
}
</script>

<style lang="less">
.userTemplate {
  height: 100%;

  .bigBox {
    padding-top: 16vh;

    .title {
      background-color: rgb(97, 165, 235);
      width: 100%;
      height: 54px;

      > div {
        font-size: 18px;
        letter-spacing: 12px;
        text-align: center;
        font-weight: bolder;
        line-height: 54px;
      }
    }

    .content {
      background-color: rgb(231, 243, 255);
      width: 100%;
      min-height: 200px;

      > div {
        padding: 15px 0;
        text-align: center;
      }
    }
  }

  .bigBox .logoPlatform {
    height: 100px;
    text-align: center;
    display: flex;
    align-items: center;

    img {
      max-width: 100%;
      max-height: 100%;
      margin: 0 auto;
    }
  }

  #cvs {
    position: absolute;
  }

}
</style>